import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Navbar from "../../components/Navbar";
import { useNavigate } from "react-router-dom";

import Section from "../../components/Section";

const GameRecord = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setIsLoading(true);

      axios
        .get("/games/" + id)
        .then((res) => {
          setData(res.data.game);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Uh Oh! Something went wrong while getting the match");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [id]);

  return (
    <Section id="game-record" className="text-center">
      <Navbar />
      {isLoading && <Loader />}
      <div className="card mt-4">
        <h1>A won match</h1>

        <h3 className="my-2">Player name: {data?.player?.name}</h3>
        <h3>Hints used: {data?.hintsUsed}</h3>
        <h3>Wrong Guesses: {data?.wrongGuesses}</h3>
        <h3>Medal: {data?.medal}</h3>
        <h3>Date: {new Date(data?.createdAt).toLocaleString()}</h3>
      </div>

      <h1 className="mt-5">{data?.player?.name}'s All Games:</h1>

      <div className="listing">
        <div className="table-container-wrap">
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Medal</th>
                  <th>Hints Used</th>
                  <th>Wrong Guesses</th>
                  <th>Date (GMT)</th>
                </tr>
              </thead>
              <tbody>
                {data?.player?.games?.map((el, idx) => {
                  const { _id, medal, hintsUsed, wrongGuesses, createdAt } = el;

                  return (
                    <tr
                      className="c-pointer"
                      onClick={() => {
                        navigate("/" + _id);
                      }}
                      key={_id}
                    >
                      <td>{medal}</td>
                      <td>{hintsUsed}</td>
                      <td>{wrongGuesses}</td>
                      <td>{new Date(createdAt).toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default GameRecord;
